import { initializeYup } from "@duosoftbg/nacid-components";
import * as yup from "yup";
import { ARUniEntryRequestRecognizedEduLevel } from "../utils/constants";

export const createARUniEntryRequestSchema = () => {
  initializeYup(yup);

  const schema = yup.object({
    applicant: yup.string().required(),
    citizenship: yup.object({
      id: yup.string().required(),
    }),
    university: yup.string().required(),
    universityCountry: yup.object({
      id: yup.string().required(),
    }),
    educationLevel: yup.string().required(),
    diplomaSpeciality: yup.string().required(),
    diplomaNumber: yup.string().optional(),
    diplomaDate: yup.string().required(),
    protocolNumber: yup.string().required(),
    protocolDate: yup.string().required(),
    recognizingUniversity: yup.object({
      universityIdentifier: yup.string().required(),
    }),
    recognizedEducationLevel: yup.mixed().when("recognitionStatus.id", {
      is: (recStatId) => recStatId !== "" && recStatId !== ARUniEntryRequestRecognizedEduLevel.DENIED,
      then: yup.object({
        id: yup.string().required(),
      }),
      otherwise: yup.object({}),
    }),
    recognizedSpeciality: yup.mixed().when(["recognitionStatus.id", "recognizedEducationLevel.id"], {
      is: (recStatId, recEduLevelId) =>
        "" !== recStatId &&
        recStatId !== ARUniEntryRequestRecognizedEduLevel.DENIED &&
        "" !== recEduLevelId &&
        "DOC" !== recEduLevelId,
      then: yup.string().required(),
      otherwise: yup.string().optional(),
    }),
    recognizedProfGroup: yup.mixed().when(["recognitionStatus.id", "recognizedEducationLevel.id"], {
      is: (recStatId, recEduLevelId) =>
        "" !== recStatId && recStatId !== ARUniEntryRequestRecognizedEduLevel.DENIED && "DOC" === recEduLevelId,
      then: yup.object({
        id: yup.string().required(),
      }),
      otherwise: yup.object({}),
    }),
    recognitionStatus: yup.object({
      id: yup.string().required(),
    }),
  });
  return schema;
};
